module.exports = __webpack_public_path__ + "static/media/w-2_06.af8fcecc.png";